var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.71,12.29L12.21,3.79l-.5-.5L8.71,.29l-1.41,1.41,2.29,2.29L1.29,12.29l-.29,.71v2l.29,.71,7,7,.71,.29h2l.71-.29,9-9v-1.41Zm-2.12,.71H3.41l7.59-7.59,7.59,7.59Zm4.41,7c0,1.1-.9,2-2,2s-2-.9-2-2c0-2,2-4,2-4,0,0,2,2,2,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFill);
export default __webpack_public_path__ + "static/1769707387/media/icon-fill.6846b68adc35bbb685c179ebccc52d6f.svg";
export { ForwardRef as ReactComponent };